export const landingVideoJson = {
  assessmentVideo: {
    videoUrl:
      "https://assets.contentstack.io/v3/assets/blt982dbc2422e29419/blt19f1e4875ecbfd01/638841cb4d172030e69a2d6f/FWD_Mind_Strength_Assessment_Test_Thai_for_TH_20221130_v2.mp4",
  },
  learningVideo: {
    videoUrl:
      "https://assets.contentstack.io/v3/assets/blt982dbc2422e29419/blt604d789c6936b302/6331616ed1176a0e3a5f7d67/Video_2.mp4",
  },
  learningCenterVideoList: [
    {
      videoKey: 'blt819490bf6bce7c7b',
      presenterName: "คุณ สุริชยา หัพนานนท์",
      presenterTitle: "ครูสอนโยคะ",
      thumbnail:
        "https://images.contentstack.io/v3/assets/blt982dbc2422e29419/blt4e68911f4629a846/63b3ceae5e9d430c0f495dbd/MicrosoftTeams-image_(4).png",
      thumbnailObjectPosition: "0",
      caption: "เสริมแกร่งให้ใจใน 10 นาที",
      videoLength: "3:23",
      videoUrl:
        "https://assets.contentstack.io/v3/assets/blt982dbc2422e29419/blt819490bf6bce7c7b/63b3d0237335502078c03468/%E0%B9%80%E0%B8%AA%E0%B8%A3%E0%B8%B4%E0%B8%A1%E0%B8%84%E0%B8%A7%E0%B8%B2%E0%B8%A1%E0%B9%81%E0%B8%81%E0%B8%A3%E0%B9%88%E0%B8%87%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B9%83%E0%B8%88%E0%B9%83%E0%B8%99_10_%E0%B8%99%E0%B8%B2%E0%B8%97%E0%B8%B5_Mind_Strength_Final_VDO_20221223.mp4",
    },
    {
      videoKey: 'blt74d56f14193f955f',
      presenterName: "คุณ บุณยวัฒน์ สมทัศน์  และ คุณ กฤตยา พรรคอนันต์",
      presenterTitle: "ผู้ก่อตั้ง บ้านกรอด้าย",
      thumbnail:
        "https://images.contentstack.io/v3/assets/blt982dbc2422e29419/bltfc68a9fffb05198f/63b3ceaec4bb1011c9ca6b68/MicrosoftTeams-image_(3).png",
      thumbnailObjectPosition: "0",
      caption: "4 ทางลัดเสริมเกราะให้ใจ",
      videoLength: "4:27",
      videoUrl:
        "https://assets.contentstack.io/v3/assets/blt982dbc2422e29419/blt74d56f14193f955f/63b3d04bbe2db12f870562bf/4_%E0%B8%97%E0%B8%B2%E0%B8%87%E0%B8%A5%E0%B8%B1%E0%B8%94_%E0%B9%80%E0%B8%AA%E0%B8%A3%E0%B8%B4%E0%B8%A1%E0%B9%80%E0%B8%81%E0%B8%A3%E0%B8%B2%E0%B8%B0%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B9%83%E0%B8%88_Mind_Strength_Final_VDO_20221223.mp4",
    },
  ],
};
